// Module
var code = "<template> <nav> <div class=\"nav-wrapper\"> <a href class=\"brand-logo right\">EssetteSuite Tests</a> <ul> <li><a route-href=\"test.date-tests\">Date/Time Tests</a></li> <li><a route-href=\"test.form-tests\">Form Tests</a></li> <li><a route-href=\"test.unit-tests\">Unit Tests</a></li> </ul> </div> </nav> </template> ";
// Exports
module.exports = code;